import { Huddle } from 'lib/generated/graphql';
import React from 'react';
import useAuth from 'src/shared-components/Auth';
import BuilderPayments from './BuilderPayments';
import CustomerPayments from './CustomerPayments';

const PaymentsComponent = ({ huddle }: { huddle: Huddle }) => {
  const user = useAuth().user;

  return (
    <div>
      {user?.role === 'CUSTOMER' && <CustomerPayments huddle={huddle} />}
      {user?.role === 'BUILDER' && <BuilderPayments huddle={huddle} />}
    </div>
  );
};

export default PaymentsComponent;
